module.exports = __webpack_public_path__ + "assets/img/img-shipin-52eda6ac.jpg";